

import { Observable } from 'rxjs'; 
import { InventoryPurchaseDetails} from './purchasedetails';
import { AnyRecord } from 'dns';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';



export interface InventoryPurchaseParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface InventoryPurchase {
  id?:any;
  
  storesupplier?: any;
 
  storeGRNNO: string;

  storeGRNDate?: any;
  
  storeSuplInvValue: any;

  storeSuplInvDate: any;

  storeSuplInvDuedate: any;

  storeSuplInvNo: string;

  storeSuplId: string;  

  storeTOTAL: any; 

  storeGRNDISCTYPE: string;

  storeGRNDISCPER: any;

  storeGRNDISCAMT: any; 

  storeGRNTAXTOTAL: any; 
  
  storeIGSTper: any;

  storeCGSTper: any;

  storeSGSTORUTGST: any; 

  storeCREDITNOTEVALUE: any;

  storeRETURNVALUE: any;

  storeROUNDOFFMODE: string;

  storeROUNDOFFAMT: any;

  storeGRNNETTOTAL?: string;

  storegrnNetTotal?: any;

  storeGRNSTATUS: string; 

  storeGRNDISCVALUE: string; 

  storecreatedDate?: string;

  storegrnDiscValue?: any; 

  storeGRNDISCTOTAL: any;
  
  storeCOMMENTS:number;
  supplier?: any;
 

  //New Column
  createdBy: any; 
  createdDate: Date;
  updatedBy: any; 
  updatedDate: Date;
  updatedIP: string;  
  createdIP: string;

  purchaseDetDto:  InventoryPurchaseDetails[];

    tenantId?: string;
    branchId?: string;    
  
    parameters?: InventoryPurchaseParameter[];
    links?: any;

    EntryFrom:number
}
export interface SupplierInvoice{
  purchaseDate : Date;
 purchaseId : string;
supplierId : string;
 supplierName:string;                               
 supplierInvNo:string;                              
 supplierInvDate :Date;
creditDays :number;
 dueDate:Date;
pendingDays:number;
 purchaseAmount:number;
purchaseReturnAmount:number;
paid:number;
balance:number;
tenantId:string;
 branchId:string;
}
export interface DistinctSupplier{
  supplierId:string;
  supplierName:string;
}
export interface consolidReport{
  supplierName:string;
 productName:string;
  category:string ;
  batchany :string;
  purchaseDate:Date;
  expiryDate :Date;
  pack:number;
  qty :number;
  freeQty:number;
  costPrice :number;
  mrp:number;
  gst_total:number;
  mrpValue:number;
  costValue:number;
}
 
export abstract class InventoryPurchaseData {
  
  abstract list(url: string): Observable<InventoryPurchase[]>;
  abstract create(url: string,data: InventoryPurchase): Observable<any>;
  abstract update(url: string,data: InventoryPurchase): Observable<any>;
  
    abstract searchSupplier_Inv_List(url: string, data:any): Observable<any>;
    
  abstract supplierList(url:string):Observable<InventoryPurchase[]>;
  abstract delete(url: string): Observable<any>;
   abstract supplierInvoiceList(url:string):Observable<SupplierInvoice[]>;
    abstract supplierInvoiceListById(url:string):Observable<any>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract consolidSupplierWiseReport(url: string,data:any): Observable<consolidReport[]>;
    abstract consolidDateWiseReport(url: string,data:any): Observable<consolidReport[]>;
    abstract distinctSupplier(url:string):Observable<any>;
      abstract searchInv_List(url: string): Observable<any>;
    
}
